import script from "./DailyGoal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DailyGoal.vue?vue&type=script&setup=true&lang=ts"

import "./DailyGoal.vue?vue&type=style&index=0&id=0241f1a6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0241f1a6"]])

export default __exports__